'use client';

import type { TooltipProps } from '@polyseme/design-system';

import { Tooltip } from '@polyseme/design-system';
import { motion } from 'framer-motion';

type Props = {
  content: TooltipProps['content'];
};

const pulseVariants = {
  animate: {
    scale: [1, 2.4],
    opacity: [0.8, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeOut' as const,
    },
  },
};

export const RippleIndicator = ({ content }: Props) => {
  const color = '#facc15';
  const size = 16;

  return (
    <Tooltip className="bg-black text-white" content={content}>
      <div className="relative hidden items-center justify-center md:flex">
        <motion.span
          animate="animate"
          className="absolute rounded-full"
          style={{
            width: size * 2,
            height: size * 2,
            backgroundColor: `${color}AA`,
          }}
          variants={pulseVariants}
        />

        <motion.span
          animate="animate"
          className="absolute rounded-full"
          style={{
            width: size * 1.5,
            height: size * 1.5,
            backgroundColor: `${color}99`,
          }}
          transition={{ delay: 1 }}
          variants={pulseVariants}
        />

        <span
          className="relative rounded-full"
          style={{
            width: size,
            height: size,
            backgroundColor: color,
          }}
        />
      </div>
    </Tooltip>
  );
};
